import React from "react";
import "./index.scss";

export default function ReportContainer(props) {
  return (
    <div className="report-container">
      <div className="scroll-container">
        {props.children}
      </div>
    </div>
  );
}
